export class ConversationWindowScrollPosition {
  messageId?: number;
  messageCount?: number;
}
